import { Box } from '@chakra-ui/react';
import { appColors } from './constants/theme';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home/Home';
import Projects from './pages/Projects';
import Experiences from './pages/Experiences';
import More from './pages/More';
import NotFound from './pages/NotFound';
import '@fontsource/cairo/300.css';
import '@fontsource/cairo/400.css';
import '@fontsource/cairo/500.css';
import '@fontsource/cairo/600.css';
import '@fontsource/cairo/700.css';

import { Global } from '@emotion/react';
function App() {
  return (
    <>
      <Global
        styles={`
          html {
            scrollbar-gutter: stable;
            background: ${appColors.mainBg};
            font-family: 'Cairo', sans-serif;
          }

          body {
            background: ${appColors.mainBg};
            font-family: 'Cairo', sans-serif;
          }
        `}
      />
      <Box minH={'100vh'} bgColor={appColors.mainBg}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/experiences" element={<Experiences />} />
          <Route path="/profile" element={<More />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Box>
    </>
  );
}

export default App;
